import axios from "axios";
import { apiURL, appURL } from "../untils/const";
import { IOrgFiledsConfigs, UserContract } from "../store/interface/user";
import { IInvitanions, IOrgMember } from "../store/interface/organization";
import { emailFormatCheck } from "../components/PasswordCheck/checks";
import { configList } from "../definitionsNew/fields";
import { defaultConfigs, IListConfing } from "../definitionsNew/configs";

export const createUser = async (
  email: string,
  userID: string,
  productId: string,
  companyName: string,
  companyAdressLine1: string,
  companyPostCode: string,
  companyCity: string,
  companyCountry: string,
  companyNip: string,
  acceptTerms: boolean,
  emailSubscription: boolean,
  lang: string,
  orgPlanName:string,
  priceID: string,
  extraTaxNumber:string,
  isCompany:boolean,
  isWaiverOfTheRightToWithdraw:boolean,
  countryMode:string
) => {
  const options = {
    email: email,
    userID: userID,
    productId: productId,
    creationTime: Date.now(),
    companyName: companyName,
    companyAdressLine1: companyAdressLine1,
    companyPostCode: companyPostCode,
    companyCity: companyCity,
    companyCountry: companyCountry,
    companyNip: companyNip,
    acceptTerms: acceptTerms,
    emailSubscription: emailSubscription,
    lang: lang,
    planName: orgPlanName,
    priceID: priceID,
    extraTaxNumber: extraTaxNumber,
    isCompany: isCompany,
    isWaiverOfTheRightToWithdraw: isWaiverOfTheRightToWithdraw,
    countryMode: countryMode
  };
  let status = false;

  await axios
    .post(`${apiURL}/user/createUserAndOrgaznization`, {
      ...options,
    })
    .then((response) => {
      sessionStorage.removeItem("paymentFlow");
      window.location.href = response.data.session.url;
    })
    .catch(function (error) {
      console.log(error);
    });
  return status;
};

export const joinUser = async (
  email: string,
  userID: string,
  invitationID: string,
  acceptTerms: boolean,
  emailSubscription: boolean
) => {
  const options = {
    email: email,
    userID: userID,
    invitationID: invitationID,
    acceptTerms: acceptTerms,
    emailSubscription: emailSubscription,
    lang: sessionStorage.getItem("lang") || "pl",
  };
  let status = false;
  await axios
    .post(`${apiURL}/user/joinUserFronInvitation`, {
      ...options,
    })
    .then((response) => {
      sessionStorage.removeItem("paymentFlow");
      window.location.href = appURL;
    })
    .catch(function (error) {
      console.log(error);
    });
  return status;
};

export interface ILimitationProps {
  projects: number;
  sections: number;
  points: number;
}

interface IResponseTagsProps {
  type: string;
  lang: string;
}

export interface IResponsePricingProps {
  id: string;
  name: string;
  priceId: string;
  price: number;
  currency: string;
  tags: IResponseTagsProps;
}

export const getLang = (detectedLang: string) => {
  let lang = "en";
  if (detectedLang) {
    if (detectedLang === "pl" || detectedLang === "pl-PL") {
      lang = "pl";
    }
  }
  return lang;
};

export const checkLang = (): string => {
  let navigatorLang = "en";
  if (navigator.language === "pl" || navigator.language === "pl-PL") {
    navigatorLang = "pl";
  }
  const lang = sessionStorage.getItem("lang") || navigatorLang;
  return lang;
};

interface ITLangObj {
  pl: string;
  en: string;
}
export const t = (obj: ITLangObj) => {
  const lang = checkLang();
  return obj[lang as keyof typeof obj];
};

//ToDo add unit test for this function
export const getContractsIDs = (userID: string, contracts: UserContract[]) => {
  const ids: string[] = [];
  contracts.forEach((_contract) => {
    ids.push(_contract.contractID);
  });
  return ids;
};

export const sendInvitationVerfication = (
  email: string,
  invitations: IInvitanions[],
  members: IOrgMember[]
) => {
  let verification = true;
  if (!emailFormatCheck(email)) {
    verification = false;
  }
  if (invitations.length > 0) {
    invitations.forEach((_invitation) => {
      if (_invitation.user === email  ) {
        verification = false;
      }
    });
  }
  members.forEach((_member) => {
    if (_member.email === email && _member.status !== "deleted") {
      verification = false;
    }
  });

  return verification;
};

export const setListConfigs = (configs: any[]) => {
  const storeConfigs: IOrgFiledsConfigs[] = [];
  const convertedConfigs: IOrgFiledsConfigs[] = [];
  if (configs) {
    Object.entries(configs).forEach(([key, value]) => {
      convertedConfigs.push({
        configName: key,
        config: value,
      });
    });
  }
  configList.map((_config) => {
    const isExist = configs
      ? convertedConfigs.find((_item) => _item.configName === _config)
      : false;
    storeConfigs.push({
      configName: _config,
      config: isExist
        ? isExist.config
        : defaultConfigs[_config as keyof typeof defaultConfigs],
    });
  });
  return storeConfigs;
};
